<template>
	<div _bg="[#FFFFFF]" style="min-height:810px;height:100%" _p="b-10px">
		<div class="ability-detail-header" @click="routeBack">
			<i class="el-icon-arrow-left" style="margin-right: 5px;font-weight: 1000;"></i>返回
		</div>
		<el-form :model="newParams" ref="newParams" label-width="100px">
			<el-form-item label="名称：" prop="origin_filename">
				<el-input
					v-model="newParams.origin_filename"
					style="width: 453px;"
					size="small"
					placeholder="名称"
					disabled
				></el-input>
			</el-form-item>
			<el-form-item label="出版社：" prop="publisher_id">
				<!-- <el-select v-model="newParams.publisher_id" size="small" _w="453px" placeholder="出版社" disabled>
					<el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select> -->
        <el-input v-model="newParams.publisher_id" style="width: 453px;" size="small" placeholder="出版社" disabled></el-input>
			</el-form-item>
			<el-form-item label="关联教材：" prop="c">
				<el-input v-model="newParams.c" style="width: 453px;" size="small" placeholder="关联教材" disabled></el-input>
			</el-form-item>
			<el-form-item label="目录：" prop="dict_ids">
				<!-- <el-cascader
					disabled
					v-model="newParams.dict_ids"
					:props="{
						value: 'id',
						label: 'direct_name',
						expandTrigger: 'click'
					}"
					:options="scopeOptions"
					:show-all-levels="false"
					placeholder="目录"
					size="small"
					_w="453px"
				></el-cascader> -->
        <el-input v-model="newParams.dict_ids" style="width: 453px;" size="small" placeholder="目录" disabled></el-input>
			</el-form-item>
			<el-form-item label="类型：" prop="file_type">
				<!-- <el-select disabled v-model="newParams.file_type" size="small" placeholder="请选择类型" _w="453px">
					<el-option v-for="item in fileType" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select> -->
        <el-input v-model="newParams.file_type" style="width: 453px;" size="small" placeholder="请选择类型" disabled></el-input>
			</el-form-item>
			<el-form-item label="文件：" prop="path">
				<div
					_flex="~ wrap"
					_w="150px"
					_pos="relative"
					_border="rounded-5px 1px solid [#cfd7e7]"
				>
					<img
						width="150px"
						style="object-fit: contain;"
						v-for="(item, index) in fileList"
						:key="index"
						_cursor="pointer"
						:src="showImage(item)"
						@click="resourceVisibleClick(item)"
					/>
				</div>
			</el-form-item>
		</el-form>
		<!-- 资源查看 -->
		<el-dialog
			custom-class="video-dialog"
			:show-close="false"
			:visible.sync="audioFlag"
			:append-to-body="true"
			:width="'350px'"
			top="40vh"
		>
			<div style="display: flex; justify-content: center; z-index: 2099; position: relative; margin-bottom: 10px;">
				<i
					class="el-icon-close"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="audioFlag = false"
					_cursor="pointer"
				></i>
				<audio ref="audioRef" @click.stop controls :src="audioResource" controlslist="noplaybackrate nodownload"></audio>
			</div>
		</el-dialog>
		<el-dialog
			custom-class="video-dialog"
			:show-close="false"
			:visible.sync="videoFlag"
			:append-to-body="true"
			:width="'509px'"
			top="32vh"
		>
			<div style="display: flex; justify-content: center; align-items: center; z-index: 2099; position: relative;">
				<i
					class="el-icon-close"
					_cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="videoFlag = false"
				></i>
				<video ref="videoRef" @click.stop controls width="500" :src="videoResource" controlslist="noplaybackrate nodownload"></video>
			</div>
		</el-dialog>
		<el-dialog :show-close="false" :visible.sync="imgFlag" :append-to-body="true" width="620px">
			<div style="display: flex; justify-content: center; padding: 10px; z-index: 2099; position: relative;">
				<i
					class="el-icon-close"
					_cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="imgFlag = false"
				></i>
				<img :src="imgResource" style="max-width: 600px; max-height: 900px;" />
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { fileType, fb_apply_volume, all_grade } from './const.js'
import { getFirstFrame } from './utils.js'
export default {
	data() {
		return {
			fb_apply_volume,
			all_grade,
			publisherIdTags: [],
			textbook: [],
			scopeOptions: [],
			newParams: {
				origin_filename: '',
				publisher_id: '',
				c: '',
				dict_ids: [],
				file_type: '',
				path: []
			},
			fileList: [],
			fileType,
			imgFlag: false,
			audioFlag: false,
			videoFlag: false,
			videoResource: '',
			audioResource: '',
			imgResource: ''
		}
	},
  watch: {
    audioFlag: {
      handler(vla) {
        if (!vla) {
          this.$refs?.audioRef?.pause()
        }
      }
    },
    videoFlag: {
      handler(vla) {
        if (!vla) {
          this.$refs?.videoRef?.pause()
        }
      }
    }
  },
	async created() {
		const { id, scope_type } = this.$route.query
		// this.getPublisherId()
		await this.editParamsEvent({ id, scope_type })
	},
	methods: {
		routeBack() {
			this.$router.go(-1)
		},
		resourceVisibleClick(item) {
			switch (this.newParams.file_type) {
				case '图片':
					this.imgResource = item.uri
					this.imgFlag = true
					break
				case '音频':
					this.audioResource = item.uri
					this.audioFlag = true
					break
				case '视频':
					this.videoResource = item.uri
					this.videoFlag = true
					break
				default:
			}
		},
		removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.children?.length >= 1) {
					item.children = this.removeEmptyItems(item.children)
				} else {
					item.children = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
		filteLabel(value, array) {
			if (!value) return
			return array[array.findIndex(item => item.value === value)]?.label || '——'
		},
		filteName(value, array) {
			if (!value) return
			return array[array.findIndex(item => item.val === value)]?.name || '——'
		},
		async editParamsEvent(row) {
			// this.row = row
			// const data = await this.$api.resource.getFileStorageDetail(row.id)
			// await this.getTextbooks({ publisher_id: data.publisher_id, scope_type: row.scope_type })
			// let book = this.textbook.find(item => item.id == data.textbook_id)
			// if (book?.directory) this.scopeOptions = this.removeEmptyItems(book?.directory)
			// this.newParams = {
			// 	origin_filename: data.origin_filename,
			// 	// c: data.directory.direct_name,
			// 	c: `${data.textbook.text_name} / ${this.filteName(
			// 		data.textbook.text_classgrade,
			// 		all_grade
			// 	)} / ${this.filteLabel(data.textbook.text_volume, fb_apply_volume)}`,
			// 	file_type: data.file_type,
			// 	publisher_id: data.publisher_id,
			// 	dict_ids: data.dict_ids,
			// 	textbook_id: data.textbook_id,
			// 	path: [
			// 		{
			// 			uri: data.path.url,
			// 			node: data.path.node
			// 		}
			// 	]
			// }
			// if (data.file_type == 3) {
			// 	const imgUrl = await getFirstFrame(data.path.url)
			// 	this.fileList = this.newParams.path.map(item => {
			// 		return {
			// 			...item,
			// 			cover: imgUrl
			// 		}
			// 	})
			// } else {
			// 	this.fileList = this.newParams.path
			// }
      const data = JSON.parse(window.localStorage.getItem('sourceDetailManagement') || {})
      const { origin_filename, text_name, direct_name, publisher, text_classgrade, text_volume, file_type, path } = data
      this.newParams.origin_filename = origin_filename
      this.newParams.publisher_id = publisher
      this.newParams.c = `${text_name} / ${text_classgrade} / ${text_volume}`
      this.newParams.dict_ids = direct_name
      this.newParams.file_type = file_type
      let imgUrl
      if (file_type == '视频') {
        imgUrl = await getFirstFrame(path)
      } else {
        imgUrl = path
      }
      this.fileList = [{ cover: imgUrl, uri: path }]
		},
		async getPublisherId() {
			const { data } = await this.$api.question_set.getPublisherId()
			this.publisherIdTags = data
		},
		async getTextbooks({ publisherId, scope_type }, argsName = 'textbook') {
			const { data } = await this.$api.resource.getTextbooks({
				fb_subject_id: this.activeId,
				fb_publisher_id: publisherId,
        scope_type: scope_type,
				page_size: 99,
				page: 1
			})
			this[argsName] = data
		},
		showImage(item) {
			return this.newParams.file_type == '图片'
				? item.uri
				: this.newParams.file_type == '视频'
				? item.cover
				: require('@/assets/image/audioResource.png')
		}
	}
}
</script>
<style scoped lang="scss">
.video-dialog {
	margin-top: 25vh;
}
.ability-detail-header {
	display: flex;
	align-items: center;
	font-size: 16px;
	padding: 15px 15px 15px 25px;
	cursor: pointer;
	margin-bottom: 20px;
}
.ability-detail-header:hover {
	color: #ff5e2a;
}
</style>
